import { i18n } from '../../../shared/helpers/i18n';
import { DATE_RANGE_TYPE } from '../constants';

export const getRangeTypeLabelMap = () => ({
    [DATE_RANGE_TYPE.FOR_3_MONTH]: i18n('conferences-history', 'for-3-month'),
    [DATE_RANGE_TYPE.SPECIFIC_MONTH]: i18n('conferences-history', 'month'),
    [DATE_RANGE_TYPE.SPECIFIC_DATES]: i18n('conferences-history', 'period'),
    [DATE_RANGE_TYPE.SPECIFIC_DATE]: i18n('conferences-history', 'day'),
});
